module.exports = __webpack_public_path__ + "static/media/blom-a-generative-art-series-by-lucastswick-sm-178.acfef6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom/blom-a-generative-art-series-by-lucastswick-sm-178.jpg
// module id = 227
// module chunks = 14